"use client";

// src/paragraph.tsx
import * as React from "react";
import { systemForwardRef } from "@stepstone-genesis/system";
import { Text } from "@stepstone-genesis/components-text";
var Paragraph = systemForwardRef(function Paragraph2({ children, variant, ...rest }, ref) {
  return /* @__PURE__ */ React.createElement(Text, { as: "p", ref, variant, ...rest }, children);
});
export {
  Paragraph
};
